var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "565 5223 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #ededed;\n      }\n\n      .cls-3 {\n        fill: #a8a8a8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(414 2325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    className: "cls-1",
    d: "M0,0H80V80H0Z",
    transform: "translate(151 2898)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sort-arrows-couple-pointing-up-and-down",
    transform: "translate(111.182 2904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273",
    transform: "translate(54.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    className: "cls-2",
    d: "M57.909,27.818h43.272a3.073,3.073,0,0,0,2.173-5.264L81.718.917a3.033,3.033,0,0,0-4.347,0L55.735,22.554a3.091,3.091,0,0,0,2.174,5.264Z",
    transform: "translate(-54.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    className: "cls-3",
    d: "M101.181,237.549H57.909a3.073,3.073,0,0,0-2.174,5.263l21.636,21.636a3.031,3.031,0,0,0,4.347,0l21.636-21.636a3.09,3.09,0,0,0-2.173-5.263Z",
    transform: "translate(-54.818 -197.366)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.2cee6e91df0934cb96dd4cd72d63fbe0.svg";
export { ForwardRef as ReactComponent };